import { onBeforeMount, ref } from 'vue';

export function useDarkMode() {
   const isDarkMode = ref(localStorage.getItem('isDark') === 'true');

   onBeforeMount(() => {
      updateTheme(isDarkMode.value);
   });

   const colorThemes = {
      light: {
         light: 'var(--black)',
         lightHover: 'var(--black-hover)',
         dark: 'var(--white)',
         darkHover: 'var(--white-hover)',
         main: 'var(--light-accent)',
         mainHover: 'var(--light-accent-hover)',
         mainLight: 'var(--light-accent-light)',
         mainLightHover: 'var(--light-accent-light-hover)',
         mainExtralight: 'var(--light-accent-extralight)',
         mainExtralightHover: 'var(--light-accent-extralight-hover)',
      },
      dark: {
         light: 'var(--white)',
         lightHover: 'var(--white-hover)',
         dark: 'var(--black)',
         darkHover: 'var(--black-hover)',
         main: 'var(--dark-accent)',
         mainHover: 'var(--dark-accent-hover)',
         mainLight: 'var(--dark-accent-light)',
         mainLightHover: 'var(--dark-accent-light-hover)',
         mainExtralight: 'var(--dark-accent-extralight)',
         mainExtralightHover: 'var(--dark-accent-extralight-hover)',
      },
   };

   function toggleDarkMode(newValue: boolean) {
      localStorage.setItem('isDark', newValue.toString());
      isDarkMode.value = newValue;
      updateTheme(newValue);
   }

   function updateTheme(value: boolean) {
      const root = document.documentElement;

      const theme = value ? colorThemes.dark : colorThemes.light;

      root.style.setProperty('--light', theme.light);
      root.style.setProperty('--light-hover', theme.lightHover);
      root.style.setProperty('--dark', theme.dark);
      root.style.setProperty('--dark-hover', theme.darkHover);
      root.style.setProperty('--main', theme.main);
      root.style.setProperty('--main-hover', theme.mainHover);
      root.style.setProperty('--main-light', theme.mainLight);
      root.style.setProperty('--main-light-hover', theme.mainLightHover);
      root.style.setProperty('--main-extralight', theme.mainExtralight);
      root.style.setProperty('--main-extralight-hover', theme.mainExtralightHover);
   }
   return { isDarkMode, toggleDarkMode };
}
